import { render, staticRenderFns } from "./cadprodutos.vue?vue&type=template&id=7c52f814&"
import script from "./cadprodutos.vue?vue&type=script&lang=js&"
export * from "./cadprodutos.vue?vue&type=script&lang=js&"
import style0 from "./cadprodutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports